export enum Environment {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  TEST = 'TEST',
  UAT = 'UAT',
  UAT2 = 'UAT-2',
  PROD = 'PROD',
}
